module.exports = __webpack_public_path__ + "static/media/close-icon-white.9303145f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/close-icon-white.svg
// module id = 846
// module chunks = 21